<template>
    <div class="contact-us" v-if="show" @click="close('form')">
        <div class="contact-box" @click.stop>
            <img class="close-icon" src="@/assets/wap/icon/close2.png" alt="" @click="close('form')">
            <div class="contact-us__title">
                <div class="contact-top">Contact Us</div>
                Please fill in your contact information, Dell Technologies representative will contact you to follow up
                shortly.
            </div>
            <div class="contact-us__form">
                <el-form :model="formInfo" :rules="rules" ref="form" label-width="170px"
                    :label-position="labelPosition">
                    <el-form-item label="First Name" prop="Fname">
                        <el-input v-model="formInfo.Fname"></el-input>
                    </el-form-item>
                    <el-form-item label="Last Name" prop="Lname">
                        <el-input v-model="formInfo.Lname"></el-input>
                    </el-form-item>
                    <el-form-item label="Company Name" prop="compName">
                        <el-input v-model="formInfo.compName"></el-input>
                    </el-form-item>
                    <el-form-item label="Job Title" prop="title">
                        <el-input v-model="formInfo.title"></el-input>
                    </el-form-item>
                    <el-form-item label="Company Email" prop="companyEmail">
                        <el-input v-model="formInfo.companyEmail"></el-input>
                    </el-form-item>
                    <el-form-item label="HK Phone Number" prop="mobile">
                        <el-input v-model="formInfo.mobile"></el-input>
                    </el-form-item>
                    <el-form-item label="Interested Products" prop="product">
                        <el-input v-model="formInfo.product"></el-input>
                    </el-form-item>
                    <el-form-item label="Budget available" prop="budgetAvailable">
                        <el-select v-model="formInfo.budgetAvailable" placeholder="Please select" style="width: 100%">
                            <el-option v-for="item in budgetOptions" :key="item.optionId" :label="item.optionValue" :value="item.optionValue"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Time frame" prop="timeFrame">
                        <el-select v-model="formInfo.timeFrame" placeholder="Please select" style="width: 100%">
                            <el-option v-for="item in timeFrameOptions" :key="item.optionId" :label="item.optionValue" :value="item.optionValue"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Decision Making Role" prop="decisionMakingRole">
                        <el-select v-model="formInfo.decisionMakingRole" placeholder="Please select" style="width: 100%">
                            <el-option v-for="item in decisionMakingRoleOptions" :key="item.optionId" :label="item.optionValue" :value="item.optionValue"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div class="contact-us__desc">
                    By clicking Submit, you agree to be contacted by
                    <a href="https://investors.delltechnologies.com/node/19326/html" target="_blank">Dell Technologies and its group of companies</a>
                    ("Dell") Sales representatives. For more information about how Dell uses, shares, and protects your personal data, read our
                    <a href="https://www.dell.com/en-hk/lp/legal/policies-privacy" target="_blank">Privacy Statement</a>.
                    If you already receive offers from Dell,
                    <a href="https://www.dell.com/preferences/ptc" target="_blank">sign in</a>
                    to manage your preference.
                </div>
            </div>
            <div class="contact-us__btn" @click="submitForm('form')">Submit ></div>
        </div>
    </div>
</template>
<script>
import store from '@/store'
import { getFormListCommon, submitFormCommon, saveUserFormInfo, getUserFormInfo } from '@/uitls/form'
export default {
    name: "ContactUs",
    props: {
        show: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            pageInfo: {},
            labelPosition: store.state.device.isPC ? 'left' : 'top',
            formList: [],
            budgetOptions: [],
            timeFrameOptions: [],
            decisionMakingRoleOptions: [],
            formInfo: {
                Fname: '',
                Lname: '',
                compName: '',
                title: '',
                companyEmail: '',
                mobile: '',
                product: '',
                budgetAvailable: '',
                timeFrame: '',
                decisionMakingRole: ''
            },
            rules: {
                Fname: [
                    { required: true, message: 'Please input', trigger: 'blur' }
                ],
                Lname: [
                    { required: true, message: 'Please input', trigger: 'blur' }
                ],
                compName: [
                    { required: true, message: 'Please input', trigger: 'blur' }
                ],
                title: [
                    { required: true, message: 'Please input', trigger: 'blur' }
                ],
                companyEmail: [
                    { required: true, message: 'Please input', trigger: 'blur' },
                    { type: 'email', message: 'Please input correct Company Email', trigger: ['blur'] }
                ],
                mobile: [
                    { required: true, message: 'Please input', trigger: 'blur' },
                    { pattern: /^[0-9]*$/, message: 'Please input correct HK Phone Number', trigger: ['blur'] }
                ],
                product: [
                    { required: true, message: 'Please input', trigger: 'blur' }
                ],
                budgetAvailable: [
                    { required: true, message: 'Please select', trigger: 'change' }
                ],
                timeFrame: [
                    { required: true, message: 'Please select', trigger: 'change' }
                ],
                decisionMakingRole: [
                    { required: true, message: 'Please select', trigger: 'change' }
                ]
            }
        }
    },
    watch: {
        show(val) {
            if (val) {
                document.body.style.overflow = 'hidden';
                this.pageInfo = JSON.parse(localStorage.getItem('pageRecord'));
                if (this.pageInfo.category2 == '列表页' || this.pageInfo.category2 == '详情页') {
                    this.formInfo.product = this.pageInfo.title;
                } else {
                    this.formInfo.product = '';
                }
                this.getData();
            } else {
                document.body.style.overflow = 'auto';
            }
        }
    },
    methods: {
        getData() {
            getFormListCommon(this).then(res => {
                this.formList = res;
                const userInfo = getUserFormInfo(this);
                if (userInfo) {
                    Object.assign(this.formInfo, userInfo);
                }
                this.budgetOptions = (res.find(i => i.displayName === 'Budget available') || {}).listOptions || [];
                this.timeFrameOptions = (res.find(i => i.displayName === 'Time frame') || {}).listOptions || [];
                this.decisionMakingRoleOptions = (res.find(i => i.displayName === 'Decision Making Role') || {}).listOptions || [];
            })
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    let data = this.formInfo;
                    data.titlePage = this.pageInfo.category2 == '列表页' ? '产品列表页' : this.pageInfo.category2 == '详情页' ? '产品详情页' : this.pageInfo.title;
                    let arr = [];
                    this.formList.forEach(item => {
                        arr.push({
                            fieldName: item.fieldName,
                            value: item.displayName == 'First Name' ? data.Fname : item.displayName == 'Last Name' ? data.Lname : item.displayName == 'Company Name' ? data.compName : item.displayName == 'Job Title' ? data.title : item.displayName == 'Company Email' ? data.companyEmail : item.displayName == 'HK Phone Number' ? data.mobile : item.displayName == 'Interested Products' ? data.product : item.displayName == 'Budget available' ? data.budgetAvailable : item.displayName == 'Time frame' ? data.timeFrame : item.displayName == 'Decision Making Role' ? data.decisionMakingRole : item.displayName == '页面title' ? data.titlePage : ''
                        })
                    })
                    submitFormCommon(this,arr).then(res => {
                        if (res) {
                            saveUserFormInfo(this, this.formInfo);
                            this.$gioAction('quotaSubmitSuccess_hk');
                            this.close('form');
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        close(formName) {
            this.$refs[formName].resetFields();
            this.$emit('close')
        }
    }
}
</script>
<style scoped lang="scss">
.contact-us {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 99;

    .contact-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 760px;
        height: auto;
        max-height: 75%;
        padding: 30px 0 0;
        background-color: #fff;
        .close-icon {
            display: block;
            position: absolute;
            top: 20px;
            right: 20px;
            width: 26px;
            height: auto;
            cursor: pointer;
        }

        .contact-us__title {
            width: 100%;
            box-sizing: border-box;
            padding-right: 50px;
            padding-left: 50px;
            padding-bottom: 20px;
            text-align: center;
            font-size: 13px;
            color: #666666;
            line-height: 17px;

            .contact-top {
                margin-bottom: 10px;
                font-weight: bold;
                font-size: 26px;
                color: #000000;
                line-height: 44px;
            }
        }

        .contact-us__form {
            width: 100%;
            max-height: 500px;
            overflow-y: auto;
            box-sizing: border-box;
            padding-left: 50px;
            padding-right: 50px;

            .el-form-item {
                margin-bottom: 14px;
            }
            :deep(.el-form-item__error) {
                padding: 0;
            }

            :deep(.el-form-item__label) {
                line-height: 44px;
                font-size: 15px;
                color: #333;
            }

            :deep(.el-input__inner) {
                height: 44px;
                line-height: 44px;
                background: #F5F6F7;
                border-radius: 6px;
                border: 1px solid #DDDDDD;
                font-size: 16px;
            }

            &::-webkit-scrollbar-track {
                background-color: transparent;
            }

            &::-webkit-scrollbar {
                width: 6px;
                background-color: transparent;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 10px;
                background-color: #999;
            }
        }

        .contact-us__desc {
            box-sizing: border-box;
            margin-top: 10px;
            font-size: 13px;
            color: #666;
            line-height: 15px;

            a {
                text-decoration: underline;
                color: #0076CE;
            }
        }

        .contact-us__btn {
            width: 100%;
            height: 50px;
            line-height: 50px;
            text-align: center;
            color: #fff;
            background-color: #0076CE;
            margin-top: 20px;
            cursor: pointer;
        }

        @include pc-style-note {
            width: 600px;
            .close-icon {
                top: 15px;
                right: 15px;
                width: 20px;
            }

            .contact-us__title {
                padding-right: 30px;
                padding-left: 30px;
                padding-bottom: 15px;

                .contact-top {
                    font-size: 20px;
                    line-height: 28px;
                }
            }

            .contact-us__form {
                max-height: 300px;
                padding-left: 30px;
                padding-right: 30px;
                font-size: 12px;
                line-height: 15px;

                .el-form-item {
                    margin-bottom: 8px;
                }

                :deep(.el-form-item__label) {
                    line-height: 30px;
                    font-size: 13px;
                    color: #333;
                }

                :deep(.el-input__inner) {
                    height: 30px;
                    line-height: 30px;
                    background: #F5F6F7;
                    border-radius: 5px;
                    border: 1px solid #DDDDDD;
                    font-size: 12px;
                }
            }
        }

        @include wap-style {
            width: 85%;
            max-height: 70%;
            padding: 6.67vw 0 0;
            overflow-y: auto;
            box-sizing: border-box;

            .close-icon {
                top: 1.33vw;
                right: 1.33vw;
                width: 5.78vw;
            }

            .contact-us__title {
                padding: 0 4vw 4vw;
                font-size: 2.87vw;
                line-height: 4vw;

                .contact-top {
                    font-size: 5.67vw;
                    line-height: 6.67vw;
                }
            }

            .contact-us__form {
                padding-right: 4vw;
                padding-left: 4vw;
                max-height: 100vh;

                .el-form-item {
                    margin-bottom: 2.67vw;
                }

                :deep(.el-form-item__label) {
                    padding: 0;
                    line-height: 3.67vw;
                }

                :deep(.el-input__inner) {
                    height: 8.8vw;
                    padding: 0 2.67vw;
                    line-height: 8.8vw;
                    background: #F5F6F7;
                    border-radius: .8vw;
                    border: 1px solid #DDDDDD;
                }
            }

            .contact-us__desc {
                font-size: 3vw;
                line-height: 4vw;
            }

            .contact-us__btn {
                height: 10.8vw;
                line-height: 10.8vw;
                font-size: 3.73vw;
                margin-top: 4.27vw;
            }
        }
    }
}
</style>